import { Box, Typography } from "@mui/material";
import AcxButton from "components/UI/AcxButton";
import AcxDialog from "components/UI/Dialog/AcxDialog";
import React from "react";
import theme from "Theme/AppTheme";

type Props = {
    name: string;
    endpointName?: string;
    isLoading: boolean;
    onCancel: () => void;
    onConfirm: () => void;
};

/**
 * A new emission body is created active, so saving the form is the moment it goes live rather
 * than a later, deliberate step. The dialog is where that is said out loud.
 */
const CreateBodyConfirmationDialog: React.FC<Props> = ({
    name,
    endpointName,
    isLoading,
    onCancel,
    onConfirm,
}) => (
    <AcxDialog
        isOpen
        onClose={onCancel}
        title={`Create “${name}”?`}
        maxWidth="xs"
        fullWidth
        buttonsDisabled={isLoading}
        dialogContentChildren={
            <Box
                sx={{ display: "flex", flexDirection: "column", gap: "14px" }}
            >
                <Typography
                    sx={{
                        fontSize: "13px",
                        lineHeight: 1.6,
                        color: theme.palette.gray.main,
                    }}
                >
                    This emission body is created active, so it starts sending
                    as soon as it is saved. Conversations that pass its rules
                    will be sent
                    {endpointName ? ` to ${endpointName}` : ""}.
                </Typography>
                <Box
                    sx={{
                        backgroundColor: theme.palette.gray[50],
                        border: `1px solid ${theme.palette.gray[200]}`,
                        borderRadius: "8px",
                        padding: "12px 14px",
                        fontSize: "12px",
                        color: theme.palette.gray[600],
                    }}
                >
                    You can disable it afterwards, which stops it sending
                    without removing it.
                </Box>
            </Box>
        }
    >
        <AcxButton
            variant="contained"
            color="primary"
            loading={isLoading}
            onClick={onConfirm}
        >
            Create and start sending
        </AcxButton>
    </AcxDialog>
)

export default CreateBodyConfirmationDialog;
